import * as React from 'react';

function SvgPerson(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M15.707 3.454C14.84 2.517 13.625 2 12.286 2c-1.346 0-2.564.513-3.429 1.446-.874.942-1.3 2.223-1.2 3.606C7.856 9.78 9.932 12 12.286 12c2.354 0 4.427-2.22 4.628-4.947.101-1.37-.327-2.649-1.207-3.599zM20.143 22H4.429a1.383 1.383 0 01-1.08-.497 1.576 1.576 0 01-.321-1.3c.377-2.09 1.553-3.845 3.4-5.078 1.643-1.094 3.723-1.697 5.858-1.697s4.215.603 5.857 1.697c1.848 1.232 3.024 2.988 3.4 5.078.088.479-.03.953-.32 1.3a1.384 1.384 0 01-1.08.497z" })));
}

export default SvgPerson;
